import { request2 } from "./request.js";

//查询考试试卷列表
let getList = function (obj, pageIndex, pageSize) {
  return request2({
    url: "/api2/TZsbAdminProductApi/Sheet/AdminSheetList",
    method: "post",
    data: {
      title: obj.title, //标题
      knowledgePointId: obj.knowledgePointId, //知识点
      tags: obj.tags, //标签 string数组
      difficultyLevel: obj.difficultyLevel, //难度
      order: obj.order || 0, //排序
      orderSet: obj.OrderSet || 0,
      pageIndex: pageIndex,
      pageSize: pageSize,
      // client: null,
    },
  });
};

//添加试卷
let addPaper = function (obj) {
  return request2({
    url: "/api2/TZsbAdminProductApi/Sheet/Insert",
    method: "post",
    data: {
      client: 3, //投放客户端
      title: obj.title, //标题
      knowledgePointId: obj.knowledgePointId, //知识点
      integral: obj.integral,
      originalPrice: obj.originalPrice,
      discountsPrice: obj.discountsPrice,
      tags: obj.tags, //标签 string数组
      difficultyLevel: obj.difficultyLevel || 0, //难度 格式化为空时，默认为0
      sheetMaxSubjects: obj.sheetMaxSubjects,
      totalScore: obj.totalScore,
      passingScore: obj.passingScore,
      timeing: obj.timeing,
      answerCount: obj.answerCount,
      hitLeve: obj.hitLeve,
      describe: obj.describe,
      keywordList: obj.keywprdList,
      yesAnswerCount: obj.yesAnswerCount,
      answerTimeStart:obj.answerTimeStart,
      answerTimeEnd:obj.answerTimeEnd,
    },
  });
};

let editPaper = function (obj) {
  return request2({
    url: "/api2/TZsbAdminProductApi/Sheet/Edit",
    method: "post",
    data: {
      id: obj.id,
      client: 3, //投放客户端
      title: obj.title, //标题
      knowledgePointId: obj.knowledgePointId, //知识点
      integral: obj.integral,
      originalPrice: obj.originalPrice,
      discountsPrice: obj.discountsPrice,
      tags: obj.tags, //标签 string数组
      difficultyLevel: obj.difficultyLevel || 0, //难度 格式化为空时，默认为0
      sheetMaxSubjects: obj.sheetMaxSubjects,
      totalScore: obj.totalScore,
      passingScore: obj.passingScore,
      timeing: obj.timeing,
      answerCount: obj.answerCount,
      hitLeve: obj.hitLeve,
      describe: obj.describe,
      keywordList: obj.keywprdList,
      yesAnswerCount: obj.yesAnswerCount,
      answerTimeStart:obj.answerTimeStart,
      answerTimeEnd:obj.answerTimeEnd,
    },
  });
};

let editLevel = function (id, level) {
  return request2({
    url: "/api2/TZsbAdminProductApi/Sheet/EditLevel",
    method: "post",
    params: {
      id: id,
      level: level, //难度
    },
  });
};

let getPaper = function (id) {
  return request2({
    url: "/api2/TZsbAdminProductApi/Sheet/Get",
    method: "get",
    params: {
      id: id,
    },
  });
};

//删除试卷
let deletePaper = function (ids) {
  return request2({
    url: "/api2/TZsbAdminProductApi/Sheet/Delete",
    method: "post",
    data: ids,
  });
};

///获取指定试卷列表--用于关联试卷与查阅试卷
let getSheetList = function (ids, keyWord, totalCount) {
  return request2({
    url: "/api2/TZsbAdminProductApi/Sheet/AdminAppointedSheetList",
    method: "post",
    data: {
      Title: keyWord, //搜索关键字
      SheetIds: ids, //指定教师iD集合
      PageSize: totalCount, //返回数目
    },
  });
};

export {
  getList,
  getPaper,
  addPaper,
  editPaper,
  editLevel,
  deletePaper,
  getSheetList,
};

// 获取学员考试记录
export function getExaminationStudentList(obj) {
  let length = obj.knowledgePointId.length || 0;
  let Ids = "";
  for (let i = 0; i < length; i++) {
    if (i == length - 1) {
      Ids += `knowledgePointId=${obj.knowledgePointId[i]}`;
    } else {
      Ids += `knowledgePointId=${obj.knowledgePointId[i]}&`;
    }
  }
  return request2({
    url: `/api2/TZsbAdminProductApi/ExaminationAdmin/GetAdminRecord?${Ids}`,
    method: "get",
    params: {
      title: obj.title,
      studentName: obj.studentName,
      telNumber: obj.telNumber,
      beginTime: obj.beginTime,
      endTime: obj.endTime,
      state: obj.state,
      pageIndex: obj.pageIndex,
      pageSize: obj.pageSize,
      BusinessId: obj.BusinessId,
      HandoverId: obj.HandoverId,
      IsSmart:obj.IsSmart,
    },
  });
}

//删除学员考试记录
export function deleteExaminationStudentRecord(ids) {
  return request2({
    url: "api2/TZsbAdminProductApi/ExaminationAdmin/DeletenExamRecord",
    method: "post",
    data: ids,
  });
}
// 添加作业考试安排
export function CreateExamination(obj) {
  return request2({
    url: "api2/TZsbAdminProductApi/ExaminationAdmin/CreateExamination",
    method: "post",
    data: {
      sheetId: obj.sheetId,
      title: obj.title,
      timeing: obj.timeing,
      totalScore: obj.totalScore,
      passingScore: obj.passingScore,
      isStop: obj.isStop,
      isScore: obj.isScore,
      isTime: obj.isTime,
      beginTime: obj.beginTime,
      knowledgePointId: obj.knowledgePointId,
      endTime: obj.endTime,
      isWeiXin: obj.isWeiXin,
      homeWorkStr: obj.homeWorkStr,
      students: obj.students1,
      examInationType: obj.examType,
      answerCount: obj.answerCount,
      // gradeId: obj.gradeId || 0,
      // gradeName: obj.gradeName,
    },
  });
}
// 添加作业考试安排
export function FileUpload(file) {
  return request2({
    url: "api2/TZsbAdminStudentApi/EducationalStudentAdmin/FileUpload",
    method: "post",
    data: file,
  });
}
// 提交作业考试安排
export function CreateExaminationImport(obj, ExamStudents) {
  return request2({
    url: "api2/TZsbAdminProductApi/ExaminationAdmin/CreateExaminationImport",
    method: "post",
    data: {
      title: obj.Title,
      adminId: obj.AdminId,
      timeing: obj.Timeing || 0,
      totalScore: obj.TotalScore || 0,
      passingScore: obj.PassingScore || 0,
      knowledgePointId: obj.knowledgePointId || 0,
      examTime: obj.ExamTime,
      examStudents: ExamStudents,
      examInationId: obj.examInationId,
      gradeId: obj.gradeId || null,
      gradeName: obj.gradeName || '',
    },
  });
}
// 获取线下考试记录
export function GetOfflineExamRecord(obj) {
  return request2({
    url: "/api2/TZsbAdminProductApi/ExaminationAdmin/GetOfflineExamRecord",
    method: "get",
    params: {
      StudentName: obj.studentName,
      Title: obj.title,
      PageIndex: obj.pageIndex,
      PageSize: obj.pageSize,
    },
  });
}

// 获取试卷id
export function getSheetById(id) {
  return request2({
    url: "/api2/TZsbAdminProductApi/Sheet/GetSheetById",
    method: "post",
    params: {
      sheetId: id,
    },
  });
}

// 更改上下架
export function editOnlineSheet(ids, isOnline) {
  return request2({
    url: `/api2/TZsbAdminProductApi/Sheet/UpdateOnlineSheet?id=${ids}&isOnline=${isOnline}`,
    method: "post",
  });
}

//设置试卷排序值
export function updateSetSort(sheetId) {
  return request2({
    url: "/api2/TZsbAdminProductApi/Sheet/GetSheetById",
    method: "get",
    params: {
      sheetId: sheetId,
    },
  });
}

// 获取试卷排序列表
export function getOrderList() {
  return request2({
    url: "/api2/TZsbAdminProductApi/Sheet/GetOrderList",
    method: "get",
  });
}

// 获取筛选
export function getOrderSetList() {
  return request2({
    url: "/api2/TZsbAdminProductApi/Sheet/GetOrderSetList",
    method: "get",
  });
}

// 批量考试记录推送消息
export function sendExamsRecordMsg(data) {
  return request2({
    url: "/api2/TZsbAdminProductApi/ExaminationAdmin/SendExamsRecordMsg",
    method: "post",
    data: data,
  });
}

// 获取待评阅考试记录
export function getReviewedsExamination(id) {
  return request2({
    url: "/api2/TZsbAdminProductApi/ExaminationAdmin/GetReviewedsExamination",
    method: "get",
    params: {
      examinationStudentId: id,
    },
  });
}

// 提交评阅结果
export function postReviewedsExamination(data) {
  return request2({
    url: "/api2/TZsbAdminProductApi/ExaminationAdmin/PostReviewedsExamination",
    method: "post",
    data: data,
  });
}

// 批量推送考试成绩通知
export function sendExaminationResults(data) {
  return request2({
    url: "/api2/TZsbAdminProductApi/ExaminationAdmin/SendExaminationResults",
    method: "post",
    data: data,
  });
}

// 批量将待公布改为待查阅
export function updatePublicsState(data) {
  return request2({
    url: "/api2/TZsbAdminProductApi/ExaminationAdmin/UpdatePublicsState",
    method: "post",
    data: data,
  });
}

// 导入线下考试安排文件 /TZsbAdminProductApi/ExaminationAdmin/ImportExaminationExecl
export function importExaminationExecl(fd) {
  return request2({
    url: "/api2/TZsbAdminProductApi/ExaminationAdmin/ImportExaminationExecl",
    method: "post",
    data: fd,
  });
}
// 批量更新考试排名-以试卷分组
export function UpdateExaminationStudentOrders(data) {
  return request2({
    url: "/api2/TZsbAdminProductApi/ExaminationAdmin/UpdateExaminationStudentOrders",
    method: "post",
    data: data,
  });
}

// 获取指定的考试安排
export function GetExaminationList(data) {
  let length = data.GradeIds.length || 0
  let Ids = ''
  for (let i = 0; i < length; i++) {
    if (i == length - 1) {
      Ids += `GradeIds=${data.GradeIds[i]}`
    } else {
      Ids += `GradeIds=${data.GradeIds[i]}&`
    }
  }
  return request2({
    url: `/api2/TZsbAdminProductApi/ExaminationAdmin/GetExaminationList?${Ids}`,
    method: "get",
    params: {
      keyword: data.keyword,
      onlyDownline: data.onlyDownline,
  },
  });
}

// 更新考试安排下的所属班级
export function UpdateExaminationGrade(data) {
  return request2({
    url: "/api2/TZsbAdminProductApi/ExaminationAdmin/UpdateExaminationGrade",
    method: "post",
    data: data,
  });
}

// 合并考试安排
export function MergeExamination(data) {
  return request2({
    url: "/api2/TZsbAdminProductApi/ExaminationAdmin/MergeExamination",
    method: "post",
    data: data,
  });
}
// 获取考试报表
export function GetExaminationStudentStatistics(data) {
  return request2({
    url: "/api2/TZsbAdminProductApi/ExaminationAdmin/GetExaminationStudentStatistics",
    method: "get",
    params: data,
  });
}
// 参考学员弹框
export function GetExamStudentListByExamId(data) {
  return request2({
    url: "/api2/TZsbAdminProductApi/ExaminationAdmin/GetExamStudentListByExamId",
    method: "get",
    params: data,
  });
}
// 更新考试安排下没有班级的学生
export function UpdateExaminationNoGradeStudent(data) {
  return request2({
    url: "/api2/TZsbAdminProductApi/ExaminationAdmin/UpdateExaminationNoGradeStudent",
    method: "post",
    params: data,
  });
}
// 修改考试安排记录的班级信息
export function UpdateExaminationStudentGradeInfo(data) {
  return request2({
    url: "/api2/TZsbAdminProductApi/ExaminationAdmin/UpdateExaminationStudentGradeInfo",
    method: "post",
    data
  });
}